export class TipoCampoSql{
    constructor(tipo, conComillas){
        this.tipo = tipo;
        this.conComillas = conComillas;
    } 
}

export class DatosCampo{
    constructor(name, alias){
        this.name = name;
        this.alias = alias;
    } 
}